import { render, staticRenderFns } from "./DirectionSelectionDialog.vue?vue&type=template&id=28d36690&scoped=true"
import script from "./DirectionSelectionDialog.vue?vue&type=script&lang=js"
export * from "./DirectionSelectionDialog.vue?vue&type=script&lang=js"
import style0 from "./DirectionSelectionDialog.vue?vue&type=style&index=0&id=28d36690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d36690",
  null
  
)

export default component.exports